import { render, staticRenderFns } from "./NewAssetImporter.vue?vue&type=template&id=1326602c"
import script from "./NewAssetImporter.vue?vue&type=script&lang=js"
export * from "./NewAssetImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports